
export type GeometryModelGeometryType = typeof GeometryModelGeometryType[keyof typeof GeometryModelGeometryType];


export const GeometryModelGeometryType = {
  None: 'None',
  Point: 'Point',
  Line: 'Line',
  Circle: 'Circle',
  Arc: 'Arc',
  Polyline: 'Polyline',
  Face: 'Face',
  Text: 'Text',
  AttDef: 'AttDef',
  Hatch: 'Hatch',
} as const;
